import {useAddItemsOneOffData} from "../../hooks/useAddItemsOneOffData";
import {useTranslation} from "react-i18next";
import {MaterialAddableTool} from "../../../../../../../../../../../models/interfaces";
import {EditorTool} from "../../../../../../../models/enums";
import {MeasurementStyleSelector} from "../../../../components/MeasurementStyleSelector";
import React from "react";
import {HeightInput} from "../../../../components/one-off/HeightInput";
import {DefaultDropInput} from "../../../../components/one-off/DefaultDropInput";
import {DefaultHeightInput} from "../../../../components/one-off/DefaultHeightInput";

const MEASUREMENT_TYPE_LABEL_KEYS: Record<string, "editor.measurementTypeLabels.count" | "editor.measurementTypeLabels.length" | "editor.measurementTypeLabels.area" | "editor.measurementTypeLabels.topViewWallArea" | "editor.measurementTypeLabels.volume"> = {
	[EditorTool.COUNT]: "editor.measurementTypeLabels.count",
	[EditorTool.LENGTH]: "editor.measurementTypeLabels.length",
	[EditorTool.AREA]: "editor.measurementTypeLabels.area",
	[EditorTool.TOP_VIEW_WALL_AREA]: "editor.measurementTypeLabels.topViewWallArea",
	[EditorTool.VOLUME]: "editor.measurementTypeLabels.volume",
};

export function AddItemsStyles(stylesContainer: ReturnType<typeof useAddItemsOneOffData>["stylesContainer"]) {
	const {t} = useTranslation();
	return (
		<div className="one-off-modal_styles">
			<div className="one-off-modal_styles_container">
				<div className="style-selector_field item-type">
					<div className={"style-selector_field_label"}>{t("projects.addItemModal.itemTypeSelectorLabel")}</div>
					<select
						onChange={(event) => stylesContainer.changeItemType(event.target.value as MaterialAddableTool)}
						value={stylesContainer.type}>
						{[EditorTool.COUNT, EditorTool.LENGTH, EditorTool.AREA, EditorTool.TOP_VIEW_WALL_AREA, EditorTool.VOLUME].map((type) =>
							<option key={type} value={type}>{t(MEASUREMENT_TYPE_LABEL_KEYS[type])}</option>)}
					</select>
				</div>
				<MeasurementStyleSelector {...stylesContainer.measurementStyleSelector} />
				{stylesContainer.heightInput ? <HeightInput {...stylesContainer.heightInput}/> : null}
				{stylesContainer.defaultDropInput ? <DefaultDropInput {...stylesContainer.defaultDropInput}/> : null}
				{stylesContainer.defaultHeightInput ? <DefaultHeightInput {...stylesContainer.defaultHeightInput}/> : null}
			</div>
		</div>
	)
}